import {
  ChartBarIcon,
  CheckBadgeIcon,
  HomeModernIcon,
} from "@heroicons/react/20/solid"
import { Link } from "gatsby"
import React from "react"
import "../styles/global.css"

export default function ContentSection2() {
  return (
    <div className="relative isolate overflow-hidden bg-white py-24 sm:py-32">
      <div
        className="absolute -top-80 left-[max(6rem,33%)] -z-10 transform-gpu blur-3xl sm:left-1/2 md:top-20 lg:ml-20 xl:top-3 xl:ml-56"
        aria-hidden="true"
      >
        <div
          className="aspect-[801/1036] w-[50.0625rem] bg-gradient-to-tr from-orange-600 to-orange-300 opacity-30"
          style={{
            clipPath:
              "polygon(63.1% 29.6%, 100% 17.2%, 76.7% 3.1%, 48.4% 0.1%, 44.6% 4.8%, 54.5% 25.4%, 59.8% 49.1%, 55.3% 57.9%, 44.5% 57.3%, 27.8% 48%, 35.1% 81.6%, 0% 97.8%, 39.3% 100%, 35.3% 81.5%, 97.2% 52.8%, 63.1% 29.6%)",
          }}
        />
      </div>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <p className="text-lg font-semibold leading-8 tracking-tight text-orange-o1">
            Satisfaction Guaranteed
          </p>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Why choose Owyhee?
          </h1>
          <p className="mt-6 text-xl leading-8 text-gray-700">
            We understand that choosing a company for your roofing needs is no
            small decision. That's exactly why our community keeps choosing us,
            year after year! Want to know our secret? Well, it’s not just one
            thing but a mix that just works.
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:mt-10 lg:max-w-none lg:grid-cols-12">
          <div className="relative lg:order-last lg:col-span-5">
            <svg
              className="absolute -top-[40rem] left-1 -z-10 h-[64rem] w-[175.5rem] -translate-x-1/2 stroke-gray-900/10 [mask-image:radial-gradient(64rem_64rem_at_111.5rem_0%,white,transparent)]"
              aria-hidden="true"
            >
              <defs>
                <pattern
                  id="e87443c8-56e4-4c20-9111-55b82fa704e3"
                  width={200}
                  height={200}
                  patternUnits="userSpaceOnUse"
                >
                  <path d="M0.5 0V200M200 0.5L0 0.499983" />
                </pattern>
              </defs>
              <rect
                width="100%"
                height="100%"
                strokeWidth={0}
                fill="url(#e87443c8-56e4-4c20-9111-55b82fa704e3)"
              />
            </svg>
            <figure className="border-l border-orange-o1 pl-8">
              <blockquote className="text-xl font-semibold leading-8 tracking-tight text-gray-900">
                <p>
                  “I worked with Owyhee Roofing after getting an outrageous
                  estimate on replacing my roof from someone else. They were
                  responsive within one day, and got to work on estimating and
                  scheduling right away. My roof looks beautiful. They were
                  professional, punctual, and very respectful of the property
                  and the clean-up afterward. Highly recommend!”
                </p>
              </blockquote>
              <figcaption className="mt-8 flex gap-x-4">
                <img
                  className="w-[50px] h-[50px] object-cover rounded-full"
                  src="/images/owyhee/denise.jpg"
                  alt="Satisfied customer Denise"
                  loading="lazy"
                />

                <div className="text-sm leading-6">
                  <div className="font-semibold text-gray-900">
                    Adrienne Anderson
                  </div>
                  <div className="text-gray-600">Satisfied Customer</div>
                </div>
              </figcaption>
            </figure>
          </div>
          <div className="max-w-xl text-base leading-7 text-gray-700 lg:col-span-7">
            <p>
              Roofing projects can be a headache when it comes to finances and
              deadlines. That's why we’re committed to ensuring your money works
              as hard as we do. We not only guarantee to meet your budget but
              also stick to the timeline we promise. No last-minute surprises.
            </p>
            <ul role="list" className="mt-8 max-w-xl space-y-8 text-gray-600">
              <li className="flex gap-x-3">
                <ChartBarIcon
                  className="mt-1 h-5 w-5 flex-none text-orange-o1"
                  aria-hidden="true"
                />
                <span>
                  <strong className="font-semibold text-gray-900">
                    Best in Class Certifications
                  </strong>{" "}
                  We work with the best suppliers in the industry and have kept
                  an impeccable record with them, allowing for amazing
                  warranties.
                </span>
              </li>
              <li className="flex gap-x-3">
                <CheckBadgeIcon
                  className="mt-1 h-5 w-5 flex-none text-orange-o1"
                  aria-hidden="true"
                />
                <span>
                  <strong className="font-semibold text-gray-900">
                    Satisfaction Guaranteed
                  </strong>{" "}
                  Never be left guessing and be assured that your project will
                  get done on-time, and on-budget.
                </span>
              </li>
              <li className="flex gap-x-3">
                <HomeModernIcon
                  className="mt-1 h-5 w-5 flex-none text-orange-o1"
                  aria-hidden="true"
                />
                <span>
                  <strong className="font-semibold text-gray-900">
                    New & Old Remodeling
                  </strong>{" "}
                  With over 25 years of experience in roofing and remodeling,
                  there isn't much we can't help you with.
                </span>
              </li>
            </ul>
            <p className="mt-8">
              Ready to team up with Owyhee Roofing, your local Boise roofing
              contractor? We're just a call or click away, ready to make your
              roofing experience hassle-free.
            </p>
            <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">
              Need financing? No problem.
            </h2>
            <p className="mt-6">
              We get it—these projects can be a chunk out of your wallet. That's
              why we offer tailored financing options, making sure your roof is
              rock solid without your budget caving in. We’re not just building
              roofs; we’re building trust, one shingle at a time.
            </p>
            <Link
              to="/financing"
              class="inline-flex items-center justify-center px-5 py-3 mr-3 mt-5 text-base font-medium text-center text-white rounded-lg bg-orange-o1 hover:bg-orange-00 focus:ring-4 focus:ring-orange-400"
            >
              Learn more about financing
              <svg
                class="w-5 h-5 ml-2 -mr-1"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
